import { withErrorBoundary } from "@sentry/nextjs";
import { FC } from "react";
import { LinkButton } from "components/Atoms/LinkButton";
import { Image } from "components/Image/Image";
import { Markdown } from "components/Markdown";
import { ArrowPointerRight } from "icons/ArrowPointerRight";
import { DataTestId } from "types/enums/testId";
import { ComponentMoleculesBillboard } from "types/graphql/generated";
interface Props {
  content: ComponentMoleculesBillboard;
}
export const Billboard: FC<Props> = withErrorBoundary(
  ({ content: { title, subTitle, primaryButton, secondaryButton, graphic } }) => {
    const image = graphic?.data?.attributes;

    return (
      <div
        data-testid={DataTestId.BillboardContainer}
        className="flex flex-col gap-6 rounded-lg bg-gradient-23 from-dusk-10 from-50% to-dusk-15 to-[114%] p-4"
      >
        <div>
          {title ? (
            <Markdown className="mb-1 text-lg font-semibold text-fog-80">{title}</Markdown>
          ) : (
            image.hash && (
              <Image
                {...image}
                src={image.hash}
                alt={image.alternativeText ?? "Billboard graphic"}
                height={32}
                width={150}
                className={"mb-4 max-h-8 object-contain object-left"}
              />
            )
          )}
          {subTitle && <Markdown className="text-sm text-black">{subTitle}</Markdown>}
        </div>
        <div className="flex gap-4">
          {primaryButton && (
            <LinkButton
              href={primaryButton.url}
              compact
              className="bg-fog-70 text-base font-semibold text-white transition-all duration-200 ease-in-out hover:bg-black focus:bg-black active:bg-black"
              rightIcon={<ArrowPointerRight fill="white" height={16} width={16} />}
            >
              {primaryButton.label}
            </LinkButton>
          )}
          {secondaryButton && (
            <LinkButton variant="ghost" href={secondaryButton.url} compact>
              {secondaryButton.label}
            </LinkButton>
          )}
        </div>
      </div>
    );
  },
  {}
);
